
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1pkvc_y97u2_9",
  "body-scroller": "awsui_body-scroller_1pkvc_y97u2_46",
  "table": "awsui_table_1pkvc_y97u2_59",
  "table-auto": "awsui_table-auto_1pkvc_y97u2_65",
  "table-grid": "awsui_table-grid_1pkvc_y97u2_69"
};
  